module.exports = __webpack_public_path__ + "img/loader-popcorn.a81a2f93.svg";